import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toPublicPath } from "../../Utils/publicRoutes";
import Button from "../Button/Button";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");

    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 w-full bg-gray-100 text-gray-800 px-16 py-10 shadow z-40 flex flex-col md:flex-row justify-between items-center gap-4">
      <div>
        <h5 className="mb-3">{"Consentimento de Cookies"}</h5>
        <p className="text-sm max-w-4xl">
          {"Utilizamos cookies para melhorar sua experiência e medir o desempenho do site."}
          <span className="block">
            {"Saiba mais em nossas"}
            <Link to={toPublicPath("/politica-privacidade")} className="text-primary-600 font-semibold hover:underline ml-1">
              {"Políticas de Privacidade"}
            </Link>
            <span className="ml-1 text-primary-600 font-semibold">{"e"}</span>
            <Link to={toPublicPath("/politica-cookies")} className="text-primary-600 font-semibold hover:underline ml-1">
              {"Políticas de Cookies"}
            </Link>
            .
          </span>
        </p>
      </div>
      
      <Button onClick={acceptCookies} className="px-4 py-2 text-sm">
        {"Aceitar"}
      </Button>
    </div>
  );
};
